module.exports = __webpack_public_path__ + "img/qiwari.0347d13f.svg";